import createRestClient from '~/utils/createRestClient';
import { useState } from 'react';

export default function useRestClient() {
  // This may need to do more later, so leaving for now
  const [restClient] = useState(createRestClient());

  return restClient;
}
